/**
 * 接口前缀分流
 */

// 上云-auz用户
const cloudAuz = [
  'doValidateToken',
  'getThirdParameters',
  'getLoginUserInfo'
]

// 上云-qry查询
const cloudQry = [
  // 'lte/putEvaluationQft',
  // 'lte/getConsoleTipsInfo'
  '/contract/isSignedLatestAgreement',
  '/contract/signAgreement',
  '/contract/versionList'
]

// 上云-ect查邮
const cloudEct = [
  // 'lte/queryPromise'
]

// 上云-exp下单
const cloudExp = [
  'getPlaceSuggestion',
  'postage/getMailPostage',
  'order/v4/appoint-time',
  'userAddress/getAddrById',
  'getAddressByLocation',
  '/order/queryProductService',
  'lte/queryPromise',
  'lte/putEvaluationQft',
  'lte/getConsoleTipsInfo',
  '/lte/putLimitEvaluation',
  '/postage/queryInsuredTypeAndLimit',
  '/getGeoAddress'
]

// 上云-ect查邮
const cloudInt = [
  '/address/queryPopularCountries',
  '/order/queryCountryInformation',
  '/order/queryBillingZoneIntlProduct',
  '/external/getOuterStandardSearch'
]

const cloudUrl = process.env.VUE_APP_CLOUD_BASE_URL

export default function assertBaseurl (url) {
  // 优先判断上云接口
  if (cloudAuz.find(item => url.includes(item))) {
    if (url.includes('getLoginUserInfo')) {
      return cloudUrl + '/ecr-auz-web/user'
    }
    return cloudUrl + '/ecr-auz-web'
  }
  if (cloudQry.find(item => url.includes(item))) {
    return cloudUrl + '/ecr-qry-web'
  }
  if (cloudEct.find(item => url.includes(item))) {
    return cloudUrl + '/ecr-ect-web'
  }
  if (cloudExp.find(item => url.includes(item))) {
    return cloudUrl + '/ecr-exp-web'
  }
  if (cloudInt.find(item => url.includes(item))) {
    return cloudUrl + '/ecr-int-web'
  }

  // 这里return一个默认值是为了预防有匹配不到需要的baseURL的情况
  return process.env.VUE_APP_AXIOS_URL
}
